// filepath: /Users/austin/workspace/docuhounds/react-frontend/src/mobile/pages/MobileAssignmentDetailsPage.js
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AssignmentApi, EndeavorApi } from '../../services/ApiService';
import AssignmentDetailsSection from '../../components/details/AssignmentDetailsSection';

export default function MobileAssignmentDetailsPage(){
  const { assignmentId } = useParams();
  const navigate = useNavigate();
  const [assignment,setAssignment]=useState(null);
  const [endeavor,setEndeavor]=useState(null);
  const [err,setErr]=useState(null);
  const [loading,setLoading]=useState(true);

  const formatDate = useCallback(d=>{
    if(!d) return 'Not set';
    try{
      const dt = new Date(d);
      if(isNaN(dt)) return 'Invalid date';
      return dt.toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'});
    }catch{return 'Invalid date';}
  },[]);

  const isOverdue = useMemo(()=>{
    if(!assignment?.dueDatetime) return false;
    return new Date(assignment.dueDatetime) < new Date() && !assignment.completed;
  },[assignment]);

  const assignmentInfo = useMemo(()=>{
    if(!assignment) return {};
    return {
      createdAt: formatDate(assignment.createdAt),
      updatedAt: formatDate(assignment.updatedAt),
      status: assignment.completed ? 'Completed' : (isOverdue ? 'Overdue' : 'Pending'),
      priority: assignment.priority || 'Medium'
    };
  },[assignment,formatDate,isOverdue]);

  useEffect(()=>{
    let active=true;
    (async()=>{
      try{
        setLoading(true);
        const aRes = await AssignmentApi.getAssignment(assignmentId);
        if(!aRes.ok) throw new Error('Failed to load assignment');
        const aData = await aRes.json();
        if(!active) return;
        setAssignment(aData);
        if (aData.endeavorId){
          const cRes = await EndeavorApi.getEndeavor(aData.endeavorId);
          if(cRes.ok){
            const cData = await cRes.json();
            if(active) setEndeavor(cData);
          }
        }
      }catch(e){
        if(active) setErr(e.message);
      }finally{
        if(active) setLoading(false);
      }
    })();
    return ()=>{active=false;};
  },[assignmentId]);

  const toggleCompleted = async () => {
    if(!assignment) return;
    try{
      const newVal = !assignment.completed;
      const payload = { ...assignment, completed:newVal, status:newVal?'Completed':'Pending' };
      const res = await AssignmentApi.updateAssignment(assignmentId,payload);
      if(res.ok) setAssignment(prev=>({...prev,completed:newVal,status:payload.status}));
    }catch(e){ alert('Update failed'); }
  };

  if(loading) return <div className="m-screen"><p>Loading assignment...</p></div>;
  if(err) return <div className="m-screen"><p>Error: {err}</p></div>;
  if(!assignment) return <div className="m-screen"><p>Not found.</p></div>;

  return (
    <div className="m-screen">
      <div className="m-page-header">
        <button className="m-back-btn" onClick={()=>navigate('/m/assignments')}>← Assignments</button>
        <div className="m-page-title">Assignment</div>
      </div>
      <AssignmentDetailsSection
        assignment={assignment}
        assignmentInfo={assignmentInfo}
        isOverdue={isOverdue}
        endeavor={endeavor}
        onToggleCompleted={toggleCompleted}
        onEdit={()=>navigate(`/m/assignment/${assignmentId}/edit`)}
        navigateToEndeavor={()=>endeavor && navigate(`/m/course/${endeavor.endeavorId||endeavor.id}`)}
        navigateToEvent={()=>assignment.eventId && navigate(`/m/event/${assignment.eventId}`)}
      />
    </div>
  );
}